/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TWebUpdateFolderModel,
  IWebUpdateFolderRequest,
  IMappers,
  IWebUpdateFolderResponse,
  IWebUpdateFolderResponseError,
  TWebUpdateFolderResponse,
} from './types';

const defaultConfig: TWebUpdateFolderModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'favorites',
  pathApi: '/v1/web/update-folder/',
  hostType: 'api',
} as TWebUpdateFolderModel;

function createWebUpdateFolderModel(parameters: IWebUpdateFolderRequest): TWebUpdateFolderModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IWebUpdateFolderOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IWebUpdateFolderRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchWebUpdateFolder<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IWebUpdateFolderOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TWebUpdateFolderResponse
> {
  const { response, statusCode } = await httpApi.fetch(createWebUpdateFolderModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IWebUpdateFolderResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IWebUpdateFolderResponseError);
    }
  }

  return { response, statusCode } as TWebUpdateFolderResponse;
}

export { defaultConfig, createWebUpdateFolderModel, fetchWebUpdateFolder };
